// Chakra Imports
import {
  Box,
  Grid,
  Icon,
  SlideFade,
  Flex,
  Link,
  VStack,
  Text
} from "@chakra-ui/react";

// API Requests
import { ApiDashboardList } from "api/dashboards/dashboard";
import { Dashboard } from "api/types";

// Custom components
import DashboardElement from "./components/dashboardElement";

// Hooks and CTX
import { useState, useEffect } from "react";
import { useAuth } from "contexts/AuthProvider";
import { useLoading } from "contexts/LoadingContext";

import { useBreakpoint } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { IoAddCircleOutline } from "react-icons/io5";
import Card from 'components/card/Card';


export default function Dashboards(props?: { containerH?: any, containerMt?: any, containerMb?: any, containerP?: any, setFN?: any }) {
  const [dashboards, setDashboards] = useState(null);
  const [screenW, setScreenW] = useState(window.screen.availWidth)
  window.addEventListener('resize', (...args) => { setScreenW(window.screen.availWidth) })

  if (!props) { sessionStorage.removeItem('dashboards') }

  const { logoutAction, user } = useAuth();
  const { show, hide } = useLoading();
  const navigate = useNavigate()

  const getDashboards = async () => {
    if (!props) { show(); }
    await ApiDashboardList()
      .then(async function (response) {
        let data: Array<any> = response.data;
        sessionStorage.setItem('dashboard-count', `${data.length}`)
        setDashboards(
          data.map((dashboard, idx) => {

            if (!dashboard.is_active) {
              return <></>
            }

            let _dashboard: Dashboard = {
              id: dashboard.id,
              name: dashboard.name,
              embedMode: dashboard.embed_mode,
              publishedUrl: dashboard.published_url,
              powerBIReportUUID: dashboard.powerbi_report_uuid,
              powerBIDatasetUUID: dashboard.powerbi_dataset_uuid,
              isActive: dashboard.is_active,
              icon: dashboard.display_icon,
              backgroundImage: dashboard.background_image,
              refreshedAt: new Date(dashboard.refreshed_at),
              createdAt: new Date(dashboard.created_at),
              deletedAt: new Date(dashboard.deleted_at),
            };

            let elementClickAction = (event: any) => {
              if (props?.setFN) {
                props.setFN('+', _dashboard)
              } else {
                sessionStorage.setItem('dashboards', JSON.stringify([_dashboard]))
                navigate('/dashboards/view')
              }
            }
            return (
              <DashboardElement
                clickAction={elementClickAction}
                dashboard={_dashboard}
                index={idx}
                key={idx}
              />
            );
          })
        );
        if (!props) { hide(); };
      })
      .catch((err) => {
        if (err.response.status === 403) { logoutAction(true) }
        if (!props) { hide(); };
      });
  };

  const breakPoint = useBreakpoint()

  const getGridColumnLayout = () => {
    let contentLength = dashboards?.length + (user.is_staff?1:0)
    let mul = contentLength
    if (breakPoint === 'sm' || breakPoint === '2sm') {
      mul = 1
    } else if ((breakPoint === 'md') && contentLength >= 2) {
      mul = 2
    } else if ((breakPoint === 'lg') && contentLength >= 3) {
      mul = 3
    } else if ((breakPoint === 'xl' || breakPoint === '2xl' || breakPoint === '3xl') && contentLength >= 4) {
      mul = 4
    }
    return '1fr '.repeat(mul).trim()
  }

  useEffect(() => {
    getDashboards();
  }, []);

  return (
    <Box
      mt={props?.containerMt ?? { base: "110px", md: "80px", lg: "70px" }}
      mb={props?.containerMb ?? { base: '30px', lg: '0px' }}
      h={props?.containerH ?? { base: '100%' }}
      position={props?.containerMt ? 'unset' : 'relative'}
      top={{ base: '0px' }}
      overflow={'scroll'}
      w='100%' justifyContent='center' display='flex'>
      <Grid
        templateColumns={getGridColumnLayout()}
        templateRows={{
          base: "repeat(3, 1fr)",
          lg: "1fr",
        }}
        justifyItems='center'
        rowGap={{ base: '20px' }}
        columnGap={{ base: '20px' }}
        w='fit-content'
        h={{ md: "100%", xl: 'fit-content' }}
        alignSelf='center'
        backgroundColor={{ base: 'transparent', md: "#0b1437" }}
        padding={props?.containerP ?? { base: "0px", xl: "30px" }}
        borderRadius="30px"
      >
        {dashboards}
        {user.is_staff && dashboards ?
          <SlideFade in={true} offsetX={dashboards.length % 2 === 0 ? '30px' : '-30px'} delay={dashboards.length / 6}>
            <Link href={`${process.env.REACT_APP_BASE_URL}/admin/dashboards/dashboard/add/`} target="_blank">
              <Card px='20px' py={{ base: '2vh' }} role='group' _hover={{ background: 'navy.700' }} onClick={() => ('x')}>
                <Flex direction={{ base: 'column' }} justify='center'>
                  <Box position='relative' backgroundColor='#0b1437' borderRadius='20px'>

                    <VStack
                      my={{ base: "6vh", xl: '7vh' }}
                      _groupHover={{ transform: 'scale(1.1)' }}
                      transition='0.2s linear'>
                      <Icon
                        as={IoAddCircleOutline}
                        w={{ base: '230px' }}
                        h={{ base: '30px' }}
                      />
                      <Text
                        fontSize='13px'
                        mb='5px'
                        alignSelf='center'
                        me='14px'>
                        Modificar Tableros
                      </Text>
                    </VStack>
                  </Box>
                </Flex>
              </Card>
            </Link>
          </SlideFade>
          : null
        }
      </Grid>
    </Box >
  );
}
